export default __webpack_public_path__ + "b0aef315c8110c185ee195872d5d946f.png";